/**
 * Featured Posts Slider
 * -----------------------------------------------------------------------------
 *
 * Initializes Flickity plugin and updates Flickity controls positioning for
 * smaller viewports.
 *
 * @see https://flickity.metafizzy.co/
 *
 * This file cribs `_slider.js` from the main site file.
 */

// Imports.
const $              = require( 'jquery' );
const Flickity       = require( 'flickity' );
const { MediaQuery } = require( '../../vendor/und/js/utilities/_media-query' );
const throttle       = require( '../../vendor/und/js/vendor/throttle/_throttle' );

require( 'flickity-imagesloaded' );



function FeaturedPostsSlider() {

  const NAMESPACE = '.und.featured-posts-slider';
  // Converting jQuery collection of elements to an array of jQuery objects
  // (from those elements).
  const $sliders  = $( '.featured-posts-slider' ).map( ( i, el ) => $( el ) );
  const offsetEls = [
    '.flickity-prev-next-button',
    '.flickity-page-dots'
  ];
  let appliedTabOrderOnceAtMD = false;



  /**
   * Initialize Flickity.
   *
   * @param {jQuery} $el Snippet container element. This is not the element
   *                     that Flickity is applied to.
   */
  function init( $el ) {

    const $slider = $el.find( '.featured-posts-slider__slides' );
    const flkty   = new Flickity( $slider[ 0 ], {
      adaptiveHeight: true,
      accessibility:  false,
      dragThreshold:  6,
      imagesLoaded:   true,
      wrapAround:     true
    } );

    applyTabOrder();

  }


  
  /**
   * Remove post headline links from tab focus at or above medium viewports.
   * 
   * Notes
   * 1. No Focus. Apply `-1` (no focus) when at or above `md` breakpoint.
   * 2. Focus when visible to user. Apply `0` (focusable) when below the `md`
   *    breakpoint.
   */
  function applyTabOrder() {

    const atLeastMD = MediaQuery.atLeast( 'md' );

    const applyTabOrderAtMD    = atLeastMD && !appliedTabOrderOnceAtMD;
    const applyTabOrderBelowMD = !atLeastMD && appliedTabOrderOnceAtMD;

    // Apply once each time viewport is resized above/below medium viewport.
    if ( applyTabOrderAtMD || applyTabOrderBelowMD ) {

      $sliders.each( function ( i, $el ) {

        const $headlineLink = $el.find( '.featured-posts-slider__slide .featured-posts-slider__headline a' );

        $headlineLink.attr( 'tabindex', atLeastMD ? -1 : 0 ); /* 1, 2 */

      } );

      appliedTabOrderOnceAtMD = !appliedTabOrderOnceAtMD;

    }

  }

  /**
   * Add event handlers.
   */
  function events() {
    
    $( window ).on( `resize${NAMESPACE}`, throttle( applyTabOrder, 25 ) );
    $( document ).on( 'mouseover focusin', '.featured-posts-slider__link', onFeaturedPostsNavInteraction );

  }

  /**
   * Advance slider based on post navigation interaction.
   *
   * Notes 
   * 1. Flickity instance.
   * 
   * @param  {Event} e The browser event.
   */
  function onFeaturedPostsNavInteraction( e ) {

    const $target   = $( e.target );
    const $nav      = $target.closest( '.featured-posts-slider__nav' );
    const $links    = $nav.children();
    const $flkty_el = $nav.next( '.featured-posts-slider__slides' );
    const flkty     = Flickity.data( $flkty_el[ 0 ] ); /* 1 */
    const index     = $links.index( $target );

    flkty.select( index );

  }



  // Setup Landing Page Sliders.
  if ( !$sliders.length ) return;

  MediaQuery._init();
  events();
  $sliders.map( ( i, $el ) => init( $el ) );

}



FeaturedPostsSlider();